import PermissionHide from 'components/PermissionHide';
import React from 'react';
import { FormattedNumber } from 'react-intl';

interface IProps {
  classes: any;
  invoice: any;
}

interface IStates {
  email: string;
}

class Cooproducer extends React.Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      email: '',
    };
  }

  getCoProducer = (invoice: any) => {
    let exist = false;
    let list = [];

    if (invoice.gains && invoice.gains.length) {
      for (let i = 0; i < invoice.gains.length; i++) {
        if (invoice.gains[i].type === 'Co-producer') {
          exist = true;
          list.push(invoice.gains[i]);
        }
      }
    }

    if (exist) {
      return list.map((item) => (
        <div className='row__cooproducer' key={'cooproducer-' + item.id}>
          <div>
            {item.name} ({item.email})
          </div>
          <div>
            <PermissionHide inverse={1} action='myeduzz:minhas-vendas:ocultar-valores'>
              <FormattedNumber value={item.amount ? item.amount : 0} format='BRL' />
            </PermissionHide>
            <PermissionHide inverse={false} action='myeduzz:minhas-vendas:ocultar-valores'>
              <em>oculto</em>
            </PermissionHide>
          </div>
        </div>
      ));
    }

    return 'Não há Co-Produtores vinculado à fatura';
  };

  render() {
    const { classes, invoice } = this.props;

    return (
      <div className={classes.affiliates}>
        <div className='affiliates__title'>
          <div>Co-Produtores</div>
          <div>Ganho</div>
        </div>

        <div className='affiliates__content --cooproducer'>{this.getCoProducer(invoice)}</div>
      </div>
    );
  }
}

export default Cooproducer;
